import { createContext } from "react";

import type { CurrencyFormatConfig } from "../utils";

/**
 * Context for currency format configuration.
 *
 * Allows apps to set currency display preferences at the root level:
 * - PropAI uses CONSUMER_CURRENCY_CONFIG (k prefix, kr/€ symbols)
 * - Platform uses TECHNICAL_CURRENCY_CONFIG (T prefix, NOK/SEK codes)
 *
 * Components like InfoCard read from this context automatically,
 * with optional prop override for edge cases.
 */
export const CurrencyFormatContext = createContext<CurrencyFormatConfig | undefined>(undefined);
